/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/radar-fetch-client";
import type { GetPreferencesQueryResponse } from "../../models/usersController/GetPreferences";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/radar-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getPreferencesQueryKey = () => [{ url: '/users/preferences' }] as const

export type GetPreferencesQueryKey = ReturnType<typeof getPreferencesQueryKey>

/**
 * @summary Get the authenticated user's saved preferences
 * {@link /users/preferences}
 */
export async function getPreferences(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetPreferencesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : `/users/preferences`, ... requestConfig })
  return res.data
}

export function getPreferencesQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getPreferencesQueryKey()
        return queryOptions<GetPreferencesQueryResponse, ResponseErrorConfig<Error>, GetPreferencesQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getPreferences({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get the authenticated user's saved preferences
 * {@link /users/preferences}
 */
export function useGetPreferences<TData = GetPreferencesQueryResponse, TQueryData = GetPreferencesQueryResponse, TQueryKey extends QueryKey = GetPreferencesQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<GetPreferencesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getPreferencesQueryKey()
         

         const query = useQuery({
          ...getPreferencesQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}